import { createFileRoute } from '@tanstack/react-router'
import { LogDetail } from '@thom/folio-ui/pages/log'

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug/logs/$log')({
	component: LogDetail,
})
